import { InfoCircleOutlined } from '@ant-design/icons';
import { InputNumber, Tooltip } from 'antd';
import React from 'react';
import { CATERING_SETUP_TIME_DETAIL, CATERING_SETUP_TIME_SUMMARY } from 'utils/cateringSetupTime';

function CateringSetupTimeInput({
  id, value, onChange, ...props
}) {
  return (
    <InputNumber
      id={id}
      min={0}
      max={240}
      step={1}
      precision={0}
      controls
      inputMode="numeric"
      value={value ?? null}
      onChange={(next) => onChange?.(next)}
      style={{ width: 100 }}
      {...props}
    />
  );
}

export function CateringSetupTimeHelp() {
  return (
    <span className="catering-setup-help">
      {CATERING_SETUP_TIME_SUMMARY}
      {' '}
      <Tooltip title={CATERING_SETUP_TIME_DETAIL}>
        <InfoCircleOutlined aria-label="More about catering setup time" />
      </Tooltip>
    </span>
  );
}

export default CateringSetupTimeInput;
